import * as service from './service'
export default {
  namespace: 'walletIncomeDetail',
  state: {
    detailList: [],
    incomeTypes: []
  },
  effects: {
    * getTypes ({ payload }, { call, put }) {
      const res = yield call(service.getTypes, payload)
      yield put({
        type: 'save',
        payload: {
          incomeTypes: JSON.parse(res.data.data)
        }
      })
      return res.data
    },
    * getTransactionsData ({ payload }, { call, put }) {
      const res = yield call(service.getTransactionsData, payload)
      yield put({
        type: 'save',
        payload: {
          detailList: res.data.data
        }
      })
      return res.data
    },
    * queryCourierServiceFee ({ payload }, { call }) {
      const res = yield call(service.queryCourierServiceFee, payload)
      return res.data
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
